export const visit = (vm, at) => {
at({ "en": { "button": { "back": "Back", "haveAnAccountLink": "Have an account? ", "signIn": "Sign in", "next": "Next" }, "title": { "createAccount": "Create your free account" }, "subtitle": { "noCreditCard": "100% free. No credit card needed." } } });
};